import React from "react";
import StyledSelect from "../../components/StyledSelect";
import { styles } from "./leadsStyles";

export function LeadsExportTab({ vm }) {
  const {
    exportDate,
    setExportDate,
    exportFormat,
    setExportFormat,
    handleExportLeads,
  } = vm;
  return (
              <div style={styles.exportContainer}>
                <h3 style={styles.sectionTitle}>Exportar Leads</h3>
                
                <div style={styles.formGroup}>
                  <label style={styles.label}>Período:</label>
                  <StyledSelect
                    value={exportDate}
                    onChange={setExportDate}
                    options={[
                      { value: "all", label: "Todos os leads" },
                      { value: "7days", label: "Últimos 7 dias" },
                      { value: "specific", label: "Data específica" }
                    ]}
                    placeholder="Período"
                  />
                  {exportDate === "specific" && (
                    <input
                      type="date"
                      style={styles.input}
                      onChange={(e) => setExportDate(e.target.value)}
                    />
                  )}
                </div>
                
                <div style={styles.formGroup}>
                  <label style={styles.label}>Formato:</label>
                  <StyledSelect
                    value={exportFormat}
                    onChange={setExportFormat}
                    options={[
                      { value: "csv", label: "CSV" },
                      { value: "json", label: "JSON" }
                    ]}
                    placeholder="Formato"
                  />
                </div>
                
                <button 
                  onClick={handleExportLeads} 
                  style={styles.button}
                >
                  Exportar Leads
                </button>
              </div>
  );
}
